export enum UserActionType {
    Create = 'create',
    Update = 'update',
    Delete = 'delete'
}
